<!-- display-desktop-09 preview — a display ad in the right rail of a desktop
     publisher page, on the same stand-in page as the other desktop placements:
     a serif wordmark, a nav row with the site tools opposite it, then the
     article. The article keeps its column on the left and the ad sits in a rail
     beside it. The unit is the same bordered card display-desktop-06 draws —
     creative full bleed across the top, copy under it — but the copy is set as a
     block: the headline, a two-line description, then a footer row with the
     advertiser on the left and the call to action opposite it. -->
<app-desktop-frame>
  <!-- START: Publisher page -->
  <div class="da-page">
    <!-- The site account button, tight against the top of the window. -->
    <div class="da-account d-flex justify-content-end">
      <i class="bi bi-person-circle" aria-hidden="true"></i>
    </div>

    <!-- The publisher wordmark. A stand-in logo, so it is set as text. -->
    <div class="da-wordmark">website</div>

    <!-- Site nav on the left, site tools on the right. -->
    <div class="da-nav d-flex flex-row align-items-start">
      <span
        *ngFor="let item of navItems"
        class="da-nav-item placeholder"
        aria-hidden="true"
      ></span>

      <div class="da-tools d-flex flex-row align-items-center ms-auto">
        <i class="bi bi-search" aria-hidden="true"></i>
        <i class="bi bi-arrow-clockwise" aria-hidden="true"></i>
        <i class="bi bi-share" aria-hidden="true"></i>
        <i class="bi bi-envelope" aria-hidden="true"></i>
        <i class="bi bi-rss" aria-hidden="true"></i>
      </div>
    </div>

    <!-- The article column and the ad rail beside it. -->
    <div class="da-content d-flex flex-row">
      <!-- The article the ad sits beside, and the lead image the window cuts
           off. Same skeleton as the placements that run above the article, just
           in a narrower share of the page. -->
      <div class="da-article">
        <div class="da-bars d-flex flex-column">
          <span
            *ngFor="let bar of bodyBars; let last = last"
            class="da-bar placeholder"
            [class.da-bar-short]="last"
            aria-hidden="true"
          ></span>
        </div>

        <div class="da-block" aria-hidden="true"></div>
      </div>

      <!-- START: Real ad -->
      <div class="da-ad">
        <a [href]="data.url" target="_blank" rel="noopener noreferrer" class="da-creative">
          <img *ngIf="creativeImage" class="da-creative-image" [src]="creativeImage" alt="" />
          <div *ngIf="!creativeImage" class="da-creative-image creative-missing">{{ missingDimensionLabel }}</div>

          <!-- Chrome the network draws over the unit, so it is decorative here.
               It gets its own white tile, as the mock has it, so it stays
               legible whatever the upload puts behind it. -->
          <span
            class="da-adchoices d-flex align-items-center justify-content-center"
          >
            <i class="bi bi-info-circle" aria-hidden="true"></i>
          </span>
        </a>

        <div class="da-card-body">
          <!-- The headline has the card's width to itself here, rather than
               sharing a row as the neighbouring rail placements have it. -->
          <a [href]="data.url" target="_blank" rel="noopener noreferrer" class="da-headline">
            {{ data.headlines[0] || "Your headline appears here" }}
          </a>

          <div class="da-desc">
            {{ data.descriptions[0] || "Your description appears here" }}
          </div>

          <div
            class="da-footer d-flex flex-row align-items-baseline justify-content-between"
          >
            <!-- The mock names the advertiser here rather than showing a mark.
                 GenSingleImagePreviewData carries no advertiser name, so this is
                 the host the destination URL resolves to — the same identity,
                 written the way the DTO has it. -->
            <span class="da-advertiser">Valamar</span>

            <!-- The mock draws Google's own English default here where the same
                 export gives the other placements the authored label, so the
                 authored text is what this renders, as everywhere else. -->
            <a [href]="data.url" target="_blank" rel="noopener noreferrer" class="da-cta d-inline-flex align-items-center">
              <span class="da-cta-label">
                {{ data.ctaText || "Your call to action" }}
              </span>
              <i class="bi bi-chevron-right" aria-hidden="true"></i>
            </a>
          </div>
        </div>
      </div>
      <!-- END: Real ad -->
    </div>
  </div>
  <!-- END: Publisher page -->
</app-desktop-frame>
